import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CreativeListComponent } from './creative-list.component';
import { CreativeListGroupHeaderComponent } from './creative-list-groupheader/creative-list-groupheader.component';
import { CreativeListItemComponent } from './creative-list-item/creative-list-item.component';
import { ExportCreativeModule } from '../../pages/manage-view/export-creative';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { SharedModule } from '../shared.module';
import { StatusDropdownComponent } from '../../pages/manage-view/status-dropdown/status-dropdown.component';
import { CreativeListItemMetaComponent } from './creative-list-item-meta/creative-list-item-meta.component';
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [CreativeListComponent, CreativeListGroupHeaderComponent, CreativeListItemComponent],
    imports: [
        CommonModule,
        ScrollingModule,
        SharedModule,
        ExportCreativeModule,
        FormsModule,
        StatusDropdownComponent,
        CreativeListItemMetaComponent
    ],
    exports: [CreativeListComponent, CreativeListGroupHeaderComponent, CreativeListItemComponent]
})
export class CreativeListModule {}
